module.exports = __webpack_public_path__ + "img/gr@2x.6c41180e.png";